// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"FidPoints_pageHeader__20_vd"};